// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d294e2b","455":"93140aa4"}[chunkId] + ".chunk.js";
};